import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import Chapter from "./Chapter";

export default function Gallery() {
  const { content, ui } = useSite();

  return (
    <section id="gallery" className="mx-auto max-w-7xl scroll-mt-28 px-6 py-24" data-testid="gallery-section">
      <Chapter num="02" title={ui.recentWork} sub={ui.gallerySub} testId="gallery-chapter" />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {content.gallery.map((url, i) => (
          <motion.div
            key={`${url}-${i}`}
            data-testid={`gallery-image-${i}`}
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
            className={`group relative overflow-hidden rounded-xl border border-navy-border ${
              i % 7 === 0 ? "row-span-2" : ""
            }`}
          >
            <img
              src={url}
              alt={`Proyecto de limpieza ${i + 1}`}
              loading="lazy"
              className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                i % 7 === 0 ? "aspect-[3/4] h-full" : "aspect-square"
              }`}
            />
            <div className="absolute inset-0 bg-volt/0 transition-colors duration-300 group-hover:bg-volt/10" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
